import { BaseService } from '../../../../core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { GenericBuildingModel } from '../../../../core/models/generic-building.model';
import { AuthService } from '../../../../core/services/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';

@Injectable({
  providedIn: 'root',
})
export class GenericBuildingService extends BaseService<GenericBuildingModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-building', authService);
  }

  /**
   * Vérifier les dépendances d'un bâtiment générique
   */
  checkDependencies(genericBuilding: GenericBuildingModel): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${genericBuilding._id}`, {});
  }

  /**
   * Réaffecter les bâtiments liés vers un autre bâtiment générique puis supprimer l'origine
   */
  changeAndDeleteGeneric(_id: string, body: any): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndDeleteGeneric/${_id}`, body);
  }
}
